<template>
  <audio
    src="./static/audio/月光奏鸣曲.mp3"
    id="Jaudio"
    class="media-audio"
    muted
    preload
    loop="loop"
  ></audio>
</template>
<script>
export default {
  computed: {
    bgmStatus() {
      return this.$store.state.bgmStatus
    }
  },
  watch: {
    bgmStatus: function() {
      let audio = document.getElementById('Jaudio')

      if (audio) {
        if (this.bgmStatus === 'on') {
          audio.muted = false
          audio.currentTime = 0
          audio.play()
        } else {
          audio.pause()
        }
      }
    }
  },
  mounted() {
    if (this.bgmStatus !== 'off') {
      this.audioAutoPlay('Jaudio')
    }
  },
  methods: {
    audioAutoPlay(id) {
      let audio = document.getElementById(id)

      if (audio) {
        audio.muted = false

        let play = function() {
          audio.play()
          document.removeEventListener('touchstart', play, false)
        }
        audio.play()
        document.addEventListener(
          'WeixinJSBridgeReady',
          function() {
            play()
          },
          false
        )
        document.addEventListener(
          'YixinJSBridgeReady',
          function() {
            play()
          },
          false
        )
        document.addEventListener('touchstart', play, false)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bgm.vue